import { useRevenueStatement } from './useRevenueStatement';

export { useRevenueStatement };
